/** Accept par défaut pour plans de session / images de trade. */
export const IMAGE_FILE_ACCEPT = ".png,.jpg,.jpeg,image/png,image/jpeg";

/** Accept pour les imports CSV membres. */
export const CSV_FILE_ACCEPT = ".csv,text/csv";

/** Vérifie qu'un fichier correspond au filtre `accept` HTML (extensions / MIME). */
export const fileMatchesAccept = (file: File, accept: string): boolean => {
    const tokens = accept
        .split(",")
        .map((token) => token.trim().toLowerCase())
        .filter(Boolean);
    if (tokens.length === 0) return true;

    const name = file.name.toLowerCase();
    const type = (file.type || "").toLowerCase();

    return tokens.some((token) => {
        if (token.startsWith(".")) {
            return name.endsWith(token);
        }
        if (token.endsWith("/*")) {
            const prefix = token.slice(0, -1);
            return type.startsWith(prefix);
        }
        return type === token;
    });
};
